import Components from './shared/pages/Components'
import Home from './public/pages/Home'
import News from './public/pages/News'
import Projects from './public/pages/Projects'
import NewsSlug from './public/pages/NewsSlug'
import ProjectSlug from './public/pages/ProjectSlug'
import ReligiousDues from './public/pages/ReligiousDues'
import ReligiousDuesSlug from './public/pages/ReligiousDuesSlug'
import GetInvolved from './public/pages/GetInvolved'
import AboutUs from './public/pages/AboutUs'
import LoginPage from './admin/pages/Login'
import PlatformInformation from './admin/pages/PlatformInformation'
import NewsAdmin from './admin/pages/News'
import NewsSlugAdmin from './admin/pages/NewsSlug'
import NewsCreate from './admin/pages/NewsCreate'
import ReligiousDuesAdmin from './admin/pages/ReligiousDues'
import ReligiousDuesSlugAdmin from './admin/pages/ReligiousDuesSlug'
import ReligiousDuesCreate from './admin/pages/ReligiousDuesCreate'
import ProjectsAdmin from './admin/pages/Projects'
import ProjectsSlugAdmin from './admin/pages/ProjectsSlug'
import ProjectsCreate from './admin/pages/ProjectsCreate'
import ProjectCategoriesAdmin from './admin/pages/ProjectCategories'
import ProjectCategoriesSlug from './admin/pages/ProjectCategoriesSlug'
import ProjectCategoriesCreate from './admin/pages/ProjectCategoriesCreate'
import ProjectJourneysAdmin from './admin/pages/ProjectJourney'
import ProjectJourneySlug from './admin/pages/ProjectJourneySlug'
import ProjectJourneyCreate from './admin/pages/ProjectJourneyCreate'
import VolunteersAdmin from './admin/pages/Volunteers'
import VolunteersSlug from './admin/pages/VolunteersSlug'
import VolunteerCreate from './admin/pages/VolunteerCreate'
import NewsletterSubscriptions from './admin/pages/NewsletterSubscriptions'
import NewsletterCampaign from './admin/pages/NewsletterCampaign'
import NewsletterCampaignSlug from './admin/pages/NewsletterCampaignSlug'
import NewsletterCampaignCreate from './admin/pages/NewsletterCampaignCreate'
import Reports from './admin/pages/Reports'
import ReportsSlug from './admin/pages/ReportsSlug'
import PaymentLog from './admin/pages/PaymentLog'
import PaymentLogSlug from './admin/pages/PaymentLogSlug'
import { TransactionFailed, TransactionSuccess } from './public/pages/TransactionStatus'
import Dashboard from './admin/pages/Dashboard'
import Donators from './admin/pages/Donators'
import DonatorsSlug from './admin/pages/DonatorsSlug'
import NewsReorder from './admin/pages/NewsReorder'
import ReligiousDuesReorder from './admin/pages/ReligiousDuesReorder'
import ProjectsReorder from './admin/pages/ProjectsReorder'

export const routes = [
    { path: '/', name: 'Home', element: <Home /> },
    { path: '/news', name: 'Appeals', element: <News /> },
    { path: '/news/:id', name: 'News', element: <NewsSlug /> },
    { path: '/projects', name: 'Projects', element: <Projects /> },
    { path: '/projects/:id', name: 'Projects', element: <ProjectSlug /> },
    { path: '/religious-dues', name: 'Religious Dues', element: <ReligiousDues /> },
    { path: '/religious-dues/:id', name: 'Religious Dues', element: <ReligiousDuesSlug /> },
    { path: '/get-involved', name: 'Get Involved', element: <GetInvolved /> },
    { path: '/about-us', name: 'About Us', element: <AboutUs /> },

    { path: '/payment-success', name: 'Transaction Success', element: <TransactionSuccess /> },
    { path: '/payment-failed', name: 'Transaction Failed', element: <TransactionFailed /> },

    { path: '/components', name: 'Components', element: <Components /> },
]

export const adminRoute = { path: '/admin/login', name: 'Login', element: <LoginPage /> }

export const authRoutes = [
    {
        path: '/admin/auth/dashboard',
        name: 'Dashboard',
        element: <Dashboard />,
    },
    {
        path: '/admin/auth/platform-information',
        name: 'Platform Information',
        element: <PlatformInformation />,
    },
    // News
    {
        path: '/admin/auth/news',
        name: 'Appeals',
        element: <NewsAdmin />,
    },
    {
        path: '/admin/auth/news/:id',
        name: 'Appeals Details',
        element: <NewsSlugAdmin />,
    },
    {
        path: '/admin/auth/news/create',
        name: 'Create Appeals',
        element: <NewsCreate />,
    },
    {
        path: '/admin/auth/news/reorder',
        name: 'Reorder Appeals',
        element: <NewsReorder />,
    },

    // Religious Dues
    {
        path: '/admin/auth/religious-dues',
        name: 'Religious Dues',
        element: <ReligiousDuesAdmin />,
    },
    {
        path: '/admin/auth/religious-dues/:id',
        name: 'Religious Dues Details',
        element: <ReligiousDuesSlugAdmin />,
    },
    {
        path: '/admin/auth/religious-dues/create',
        name: 'Create Religious Dues',
        element: <ReligiousDuesCreate />,
    },
    {
        path: '/admin/auth/religious-dues/reorder',
        name: 'Reorder Religious Dues',
        element: <ReligiousDuesReorder />,
    },

    // Projects
    {
        path: '/admin/auth/projects',
        name: 'Projects',
        element: <ProjectsAdmin />,
    },
    {
        path: '/admin/auth/projects/:id',
        name: 'Project Details',
        element: <ProjectsSlugAdmin />,
    },
    {
        path: '/admin/auth/projects/create',
        name: 'Create Project',
        element: <ProjectsCreate />,
    },
    {
        path: '/admin/auth/projects/reorder',
        name: 'Reorder Project',
        element: <ProjectsReorder />,
    },

    // Project Categories
    {
        path: '/admin/auth/project-categories',
        name: 'Project Categories',
        element: <ProjectCategoriesAdmin />,
    },
    {
        path: '/admin/auth/project-categories/:id',
        name: 'Project Category Details',
        element: <ProjectCategoriesSlug />,
    },
    {
        path: '/admin/auth/project-categories/create',
        name: 'Create Project Category',
        element: <ProjectCategoriesCreate />,
    },

    // Project Journey
    {
        path: '/admin/auth/project-journeys',
        name: 'Project Journeys',
        element: <ProjectJourneysAdmin />,
    },
    {
        path: '/admin/auth/project-journeys/:id',
        name: 'Project Journey Details',
        element: <ProjectJourneySlug />,
    },
    {
        path: '/admin/auth/project-journeys/create',
        name: 'Create Project Journey',
        element: <ProjectJourneyCreate />,
    },

    // Volunteers
    {
        path: '/admin/auth/volunteers',
        name: 'Project Volunteers',
        element: <VolunteersAdmin />,
    },
    {
        path: '/admin/auth/volunteers/:id',
        name: 'Project Volunteer Data',
        element: <VolunteersSlug />,
    },
    {
        path: '/admin/auth/volunteers/create',
        name: 'Create Project Volunteer',
        element: <VolunteerCreate />,
    },

    // Newsletter subscribes
    {
        path: '/admin/auth/email-subscribers',
        name: 'Newsletter Subscribers',
        element: <NewsletterSubscriptions />,
    },

    // Newsletter Campaign
    {
        path: '/admin/auth/email-campaigns',
        name: 'Newsletter Campaign',
        element: <NewsletterCampaign />,
    },
    {
        path: '/admin/auth/email-campaigns/:id',
        name: 'Newsletter Campaign Details',
        element: <NewsletterCampaignSlug />,
    },
    {
        path: '/admin/auth/email-campaigns/create',
        name: 'Create Newsletter Campaign',
        element: <NewsletterCampaignCreate />,
    },

    // Manage donations
    {
        path: '/admin/auth/donations',
        name: 'Donations',
        element: <Reports />,
    },
    {
        path: '/admin/auth/donations/:id',
        name: 'Donation Details',
        element: <ReportsSlug />,
    },

    // Payment Logs
    {
        path: '/admin/auth/payment-logs',
        name: 'Payment Logs',
        element: <PaymentLog />,
    },
    {
        path: '/admin/auth/payment-logs/:id',
        name: 'Payment Log Details',
        element: <PaymentLogSlug />,
    },

    // Donators
    {
        path: '/admin/auth/donation-billings',
        name: 'Donators',
        element: <Donators />,
    },
    {
        path: '/admin/auth/donation-billings/:id',
        name: 'Donator Details',
        element: <DonatorsSlug />,
    },
]
